import axios from "axios";
import backServer from "./ServerInfo";


export function svcInquiryCount(filter) {
    return new Promise(function(resolve,reject){
        axios.post(backServer + "/getinquirycount",
        {
          filter:filter,
          DBId:1
        },
        {headers:{"Authorization":"Bearer "+sessionStorage.getItem("jKey")}})
        .then(response => {
            resolve(response.data);
        })
        .catch(error => {
            console.log(error);
        })
    })
}

export function svcInquiryChats(inquiryId) {
    return new Promise(function(resolve,reject){
        axios.post(backServer + "/inquirychats",
        {
          filter:inquiryId,
          DBId:1
        },
        {headers:{"Authorization":"Bearer "+sessionStorage.getItem("jKey")}})
        .then(response => {
            resolve(response.data);
        })
        .catch(error => {
            console.log(error);
        })
    })
}

export function svcReplyChat(data) {
    return new Promise(function(resolve,reject){
        axios.post(backServer + "/replychat",
        data,
        {headers:{"Authorization":"Bearer "+sessionStorage.getItem("jKey")}})
        .then(response => {
            resolve(response);
        })
        .catch(error => {
            console.log(error);
        })
    })
}

export function svcInquiryList(start,limit,filter) {
  console.log("Filter before send: "+filter)
    return new Promise (function(resolve,reject){
        axios.post(backServer + "/listinquiries",
        {
            start:(start-1)*limit,
            limit:limit,
            filter:filter,
            DBId:1
        },
		{headers:{"Authorization":"Bearer "+sessionStorage.getItem("jKey")}})
        .then(response => {
            console.log(response.data);
            if(response.data.status === "fail") {
                console.log("comm not ok");
                reject();
            } else {
                console.log("comm ok");
                console.log(response);
                resolve(response.data);
            }
        })
        .catch(error => {
//            console.log("ServiceLogin.js : svcLoginCheckPost : error axios");
            window.location="/admin/login";
            reject();
        });
    });
}


export function svcAddReply(value) {
    return new Promise (function(resolve,reject){
        axios.post(backServer + "/replyinquiry",
        value,
        {headers:{"Authorization":"Bearer "+sessionStorage.getItem("jKey")}})
        .then(response => {
            if(response.data.status === "fail") {
                reject();
            } else {
                resolve();
            }
        })
        .catch(error => {
            reject();
        });
    });
}
